import BotTable from '/src/features/bot/components/BotTable/BotTable';
import BotSharedTable from '/src/features/bot/components/BotSharedTable/BotSharedTable';
import {PageTable, Header} from '/src/layouts/page';
import SliderTab from '/src/components/slider/sliderTab/SliderTab';
import storage from '/src/utils/storage';
function BotList() {

    const company = storage('session').get('company');

    const items =  [
        {name : 'Custom', component : <BotTable/>},
        {name : 'Template', component : <BotSharedTable/>}
    ]

	return (
        <PageTable name="bot">
            <Header title="List of Bots"></Header>
            <SliderTab items={items}></SliderTab>
        </PageTable>
    );
}

export default BotList;